import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerTurnosConPresente = styled(motion.div)`
  width: 100vw;
  height: 680px;
  
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  overflow-y: scroll;
  padding-bottom: 20px;
  gap: 20px;
  margin-top: 20px;

  .btn-recepcionables {
    position: absolute;
    right: 20%;
    bottom: 20px;
    margin: auto;
  }
  .turnos {
      width: 276px;
      min-height: 53px;
      border-radius: 8px;
      margin: auto;
      background: var(--color-latex30);
      color: var(--color-white);
      font-weight: 700;
      font-size: 18px;
   }
`;
